import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import iconsList from "../../ui/icons/iconsList";
import googleMeetImgStudent from "../../../../assests/googleMeet/googleMeetWidgetStudent.png";

const GoogleMeetStudentCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#7ED0FF"
            title={texts.googleMeet}
            image={googleMeetImgStudent}
            imageAlt={texts.googleMeet}
            icon={iconsList.googleMeet}
            link={`/${pathRouts.GOOGLEMEET}`}
        />
    );
};

export default GoogleMeetStudentCarouselWidget;
